var l;
const f = typeof process < "u" && ((l = process.env) == null ? void 0 : l.NODE_ENV) !== "production" || typeof import.meta < "u" && !1, o = /* @__PURE__ */ new Set();
function i(e) {
  if (!f) return;
  let c, n, t = "component", a, r;
  "component" in e ? (c = e.component, n = e.prop, a = e.replacement, n && (t = "prop")) : (c = e.name, n = e.key, t = e.type || "component", a = e.replacement, r = e.since);
  const m = n ? `${t} "${n}"` : t, p = r ? ` (since ${r})` : "", d = a ? ` Use "${a}" instead.` : "", s = `[Design System] ${c} ${m} is deprecated${p} and will be removed in a future major release.${d}`;
  o.has(s) || (o.add(s), console.warn(s));
}
export {
  i as w
};
